import { render, staticRenderFns } from "./UploadOrganisationPictures.vue?vue&type=template&id=15730553"
import script from "./UploadOrganisationPictures.vue?vue&type=script&lang=js"
export * from "./UploadOrganisationPictures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports